import PageHeader from '@shared/components/PageHeader'
import SEO from '@shared/components/SEO'
import { DOC_PAGES, getDocPage } from '../data/site-pages'
import StructuredContent, { headingsOf } from './StructuredContent'
import OnThisPage, { type RelatedLink } from './OnThisPage'

const SLUG_PATH: Record<string, string> = {
    'plagiarism-ai-policy': '/plagiarism-ai-policy',
    instructions: '/instructions'
}

function relatedLinks(slug: string, eyebrow: string): RelatedLink[] {
    return Object.entries(DOC_PAGES)
        .filter(([s, p]) => s !== slug && p.eyebrow === eyebrow)
        .slice(0, 5)
        .map(([s, p]) => ({ to: SLUG_PATH[s] ?? `/${s}`, label: p.title }))
}

export default function DocPage({ slug, path }: { slug: string; path: string }) {
    const page = getDocPage(slug)

    if (!page) {
        return (
            <section className="section">
                <SEO title="Page not found" path={path} noIndex />
                <div className="container-prose text-center">
                    <div className="eyebrow eyebrow--center">Not found</div>
                    <h1 className="font-display mt-3" style={{ fontSize: '2rem', color: 'var(--color-ink-700)' }}>
                        “{slug}” is missing
                    </h1>
                </div>
            </section>
        )
    }

    const headings = headingsOf(page.blocks)
    const showContents = headings.length >= 3
    const related = relatedLinks(slug, page.eyebrow)

    return (
        <>
            <SEO title={page.title} description={page.lede.slice(0, 160)} path={path} />
            <PageHeader eyebrow={page.eyebrow} title={page.title} lede={page.lede} />
            <section className="section">
                {showContents ? (
                    <div className="container-prose grid lg:grid-cols-[15rem_1fr] gap-12 lg:gap-16 items-start">
                        <OnThisPage headings={headings} related={related} />
                        <div style={{ minWidth: 0 }}>
                            <StructuredContent blocks={page.blocks} />
                        </div>
                    </div>
                ) : (
                    <div className="container-prose">
                        <StructuredContent blocks={page.blocks} />
                    </div>
                )}
            </section>
        </>
    )
}
